export interface IAlcoolType {
  icon: string
  label: string
  dosage: string
  resultLabel: string
  targetState: string
}

export const alcoolList: IAlcoolType[] = [
  {
    icon: 'demi',
    label: 'Demi de bière',
    dosage: '25cl',
    resultLabel: 'demi(s) de bières',
    targetState: 'beerCount',
  },
  {
    icon: 'fort',
    label: "Verre d'alcool",
    dosage: 'fort 2,5cl',
    resultLabel: "verre(s) d'alcool fort",
    targetState: 'strongAlcoolCount',
  },
  {
    icon: 'vin',
    label: 'Verre de vin',
    dosage: '10cl',
    resultLabel: 'verre(s) de vin',
    targetState: 'wineCount',
  },
  {
    icon: 'cocktail',
    label: 'Cocktail avec ',
    dosage: "2,5cl d'alcool",
    resultLabel: 'cocktail(s)',
    targetState: 'cocktailCount',
  },
]



// WEBPACK FOOTER //
// ./src/constants/alcoolList.ts